module.exports = __webpack_public_path__ + "static/media/1.9b99e187.svg";